import type React from "react";

import { Box, Button, MenuItem, Select, Typography } from "@mui/material";

export const PAGINATION_LIMIT_OPTIONS = [10, 20, 50, 100] as const;

interface PaginatedListControlsProps {
  limit: number;
  total: number;
  hasNext: boolean;
  hasPrevious: boolean;
  onLimitChange: (limit: number) => void;
  onNext: () => void;
  onPrevious: () => void;
  label?: string;
}

export function PaginatedListControls({
  limit,
  total,
  hasNext,
  hasPrevious,
  onLimitChange,
  onNext,
  onPrevious,
  label = "Items per page",
}: PaginatedListControlsProps): React.ReactElement {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        mt: 2,
        flexWrap: "wrap",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {total} total
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
        <Select
          size="small"
          value={limit}
          onChange={(event) => onLimitChange(Number(event.target.value))}
          inputProps={{ "aria-label": label }}
        >
          {PAGINATION_LIMIT_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
        <Button size="small" onClick={onPrevious} disabled={!hasPrevious}>
          Previous
        </Button>
        <Button size="small" onClick={onNext} disabled={!hasNext}>
          Next
        </Button>
      </Box>
    </Box>
  );
}
